import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters/language/language.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { StatusService } from 'src/app/modules/core/services/parameter';
import { IMachineStatus } from 'src/app/modules/widget/interfaces/machine-status';

@Component({
  selector: 'app-change-park',
  templateUrl: './change-park.component.html',
  styleUrls: ['./change-park.component.scss'],
})
export class ChangeParkComponent implements OnInit {
  @Input() public machineSelected: IMachineStatus;

  public btnDisabled = true;
  public message: string;
  public fmPark: FormGroup;
  public parkZone: [] = [];
  public hasMessage = false;
  public hasError = false;
  private initialFormValue: any;

  constructor(
    public parameterService: ParameterHandlerService,
    public languageService: LanguageService,
    public activeModal: NgbActiveModal,
    private googleAnalyticsService: GoogleAnalyticsService,
    private statusService: StatusService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    // Get available zones from Storage
    const availableZones = sessionStorage.getItem('availableZones');
    this.parkZone = availableZones ? JSON.parse(availableZones) : [];

    // Init and listen to form changes
    this.initializeForm();
    this.listenToFormChanges();

    // Google Analytics
    const customEvent = {
      modal_widget: 'asarco_state',
      tab_mo43dal: 'asarco_state_change-park',
    };
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }

  /**
   * Initializes the form with default values and validators
   */
  private initializeForm(): void {
    this.fmPark = this.fb.group({
      selectPark: new FormControl(this.machineSelected.mineId, Validators.required),
    });

    this.initialFormValue = JSON.parse(JSON.stringify(this.fmPark.value));
  }

  /**
   * Listens to form changes to enable/disable the button dynamically
   */
  private listenToFormChanges(): void {
    this.fmPark.valueChanges.subscribe(() => {
      this.evaluateButtonState();
    });
  }

  /*
   * Function to update the park zone
   */
  public updateParkZone(): void {
    if (this.fmPark.valid) {
      const selectedZone = this.fmPark.get('selectPark')?.value;

      const params = {
        machineId: this.machineSelected.machineId,
        mineId: selectedZone?.zoneId,
        userId: this.parameterService.parameters.item('user-data').value.id,
      };

      this.statusService.updateStatusParkZone(params).subscribe({
        next: (data) => {
          if (data.error.errorNumber === 0) {
            this.hasMessage = true;
            this.hasError = false;
            this.message = this.languageService.message('park change successfull');
            this.btnDisabled = true;
            this.initialFormValue = JSON.parse(JSON.stringify(this.fmPark.value));
          } else {
            this.hasMessage = true;
            this.hasError = true;
            this.message = this.languageService.message('status change error');
          }
        },
        error: (error) => {
          console.error(error);
          this.hasMessage = true;
          this.hasError = true;
          this.message = this.languageService.message('status change error');
        },
      });
    } else {
      console.warn('Formulario no válido');
      this.hasMessage = true;
      this.hasError = true;
      this.message = this.languageService.message('status change error');
    }
  }

  /**
   * Evaluates if the button should be disabled based on form state
   */
  private evaluateButtonState(): void {
    const currentValue = this.fmPark.value;
    const hasChanged = JSON.stringify(currentValue) !== JSON.stringify(this.initialFormValue);
    const isValid = this.fmPark.valid;
    this.btnDisabled = !(isValid && hasChanged);
  }

  public cancel(): void {
    this.fmPark.patchValue(this.initialFormValue, { emitEvent: false });
    this.evaluateButtonState(); // Evaluar el estado después del patchValue
    this.hasMessage = false;
    this.hasError = false;
    this.message = '';
  }
}
